/**
 *
 * leave request Page
 *
 */
import Select from "react-select"
import React, { useEffect, useState } from "react"
import MetaTags from "react-meta-tags"
import PropTypes from "prop-types"
// import Modal from "react-bootstrap/Modal"
import {
  Container,
  Row,
  Col,
  Button,
  Card,
  CardBody,
  Label,
  Input,
  Spinner,
} from "reactstrap"
import { withRouter } from "react-router-dom"
import { connect } from "react-redux"
import Modal from "react-bootstrap/Modal"
import { useSelector, useDispatch } from "react-redux"
//Import Breadcrumb
import Breadcrumbs from "../../components/Common/Breadcrumb"
// dispatch actions
import * as highValueLeadAction from "../../store/aGlnaFZhbHVlU3VtbWFyeQ/actions"
import { isEmpty } from "lodash"
import ButtonSpinner from "../../components/ButtonSpinner"

//date format
import moment from "moment"
import BootstrapTable from "react-bootstrap-table-next"
import { ToastContainer } from "react-toastify"
import paginationFactory, {
  PaginationProvider,
  PaginationListStandalone,
  SizePerPageDropdownStandalone,
  PaginationTotalStandalone,
} from "react-bootstrap-table2-paginator"
import ToolkitProvider from "react-bootstrap-table2-toolkit"
import { ReactSearchAutocomplete } from "react-search-autocomplete"
// import cellEditFactory, { Type } from "react-bootstrap-table2-editor"
import "./styles.scss"
import api from "helpers/Api"

const HighValueLeadSummary = (props) => {
  const title = "High Value Lead Summary"

  const { dispatch, searchBtnStyle } = props
  const specificDispatch = useDispatch()

  const [downloadLoading, setDownloadLoading] = useState(false)

  useEffect(() => {
    dispatch(highValueLeadAction.loadRecordsMetaData())
    dispatch(
      highValueLeadAction.loadHighValueLead({
        page: 1,
        limit: 50,
      })
    )
    setValueData(true)
  }, [])

  const permissionUpdate = useSelector(
    (specificstate) => specificstate.highValueSummary
  )
  const { recordsMetaData = {}, highValueLead_details = [] } = permissionUpdate

  // Date format
  const sessionUpdate = useSelector((specificstate) => specificstate.session)
  const { user = [] } = sessionUpdate
  const authUser = localStorage.getItem("authUser")

  const responseLogin = JSON.parse(authUser)

  //Date format
  const dateSetting =
    !isEmpty(responseLogin) &&
    responseLogin.setting &&
    responseLogin.setting.dateFormate
      ? responseLogin.setting.dateFormate.toUpperCase()
      : !isEmpty(user) && user.setting && user.setting.dateFormate
      ? user.setting.dateFormate.toUpperCase()
      : []

  const dateFormate = !isEmpty(dateSetting) && dateSetting ? dateSetting : ""

  //Access section end

  const [btnLoader, setBtnLoader] = useState(false)
  const [followupData, setFollowupData] = useState({
    company: [],
    branch: [],
    managerName: "",
    fromDate: "",
    toDate: "",
  })
  const handleChange = async (e) => {
    setFollowupData({ ...followupData, [e.target.name]: e.target.value })
  }
  //dropdown list
  const [companies, setCompanies] = useState([])
  const [branches, setBranches] = useState([])
  const [salesUrge, setSalesUrge] = useState([])
  const [event, setEvent] = useState([])
  const [leadStatus, setLeadStatus] = useState([])
  const [managerName, setManagerName] = useState([])
  const [leadSubStatus, setLeadSubStatus] = useState([])

  //Count section
  const [counterData, setCounterData] = useState(false)
  const [valueData, setValueData] = useState(false)
  const [leadMode, setLeadMode] = useState("")

  console.log(leadMode, "leadMode")

  //lead sub status options
  const leadSubStatusOptions = [
    { label: "Open", value: "Open" },
    { label: "Followup", value: "Followup" },
    { label: "Need time to think", value: "Need time to think" },
    { label: "Almost Confirm", value: "Almost Confirm" },
    { label: "Booked", value: "Booked" },
    { label: "Non Contactable", value: "Non Contactable" },
    {
      label: "Not Interested & Already Booked",
      value: "Not Interested & Already Booked",
    },
    {
      label: "Not Interested & Not Booked",
      value: "Not Interested & Not Booked",
    },
    { label: "Rejected", value: "Rejected" },
    { label: "Yet to action", value: "Yet to action" },
  ]

  //dropdown options api
  const branchOptions =
    !isEmpty(recordsMetaData) &&
    recordsMetaData.branchOptions.filter(
      (branch) => branch.companyId === companies.value
    )

  const employeeOptions =
    !isEmpty(recordsMetaData) && recordsMetaData.employeeOptions
  const fuseOptions = {
    keys: ["empCode", "label"],
  }

  //Pagination state section
  const [pageCount, setPageCount] = useState(false)
  const [btnLoading, setBtnLoading] = useState(false)
  const [pageChange, setPageChange] = useState(false)
  const [searchInput, setSearchInput] = useState("")

  //Apply filter
  const handleFilter = (e) => {
    e.preventDefault()
    var searchCompany = companies && companies ? companies.value : ""
    var searchBranch = branches && branches ? branches.value : ""
    var searchEvent = event && event ? event.value : ""
    var searchLeadStatus = leadStatus && leadStatus ? leadStatus.value : ""
    var searchManagerName = managerName && managerName ? managerName.value : ""
    var searchFromDate =
      followupData && followupData.fromDate
        ? moment(followupData.fromDate).format("YYYY-MM-DD")
        : ""
    var searchToDate =
      followupData && followupData.toDate
        ? moment(followupData.toDate).format("YYYY-MM-DD")
        : ""
    var searchSalesUrge = salesUrge && salesUrge ? salesUrge.value : ""
    var searchLeadSubStatus = leadSubStatus ? leadSubStatus.value : ""
    var searchvalue = {}
    searchvalue.page = pageChange ? pageCount : 1
    searchvalue.limit = 50
    if (searchCompany) {
      searchvalue.companyId = searchCompany
    }
    if (searchBranch) {
      searchvalue.branchId = searchBranch
    }
    if (searchEvent) {
      searchvalue.eventId = searchEvent
    }
    if (searchLeadStatus) {
      searchvalue.leadStatus = searchLeadStatus
    }
    if (searchLeadSubStatus) {
      searchvalue.leadSubStatus = searchLeadSubStatus
    }
    if (searchManagerName) {
      searchvalue.assignEmp = searchManagerName
    }
    if (searchFromDate) {
      searchvalue.fromDate = searchFromDate
    }
    if (searchToDate) {
      searchvalue.toDate = searchToDate
    }
    if (searchSalesUrge) {
      searchvalue.salesUrge = searchSalesUrge
    }
    //     setSearchValueList(searchvalue)
    setPageLoad(!pageLoad)
    console.log("searchCompany", searchvalue)
    specificDispatch(highValueLeadAction.loadHighValueLead(searchvalue))
    setBtnLoader(true)
    setBtnLoading(true)
    setTimeout(() => {
      setBtnLoading(false)
      setBtnLoader(false)
    }, 2000)
  }
  const [resetManager, setResetManager] = useState(false)
  //const today = moment().format("YYYY-MM-DD")
  //reset functionalities
  const resetForm = () => {
    setCompanies([])
    setBranches([])
    setLeadStatus([])
    setEvent([])
    setManagerName(null)
    setSalesUrge([])
    setLeadSubStatus([])
    setFollowupData({
      fromDate: "",
      toDate: "",
    })

    setResetManager(true)
    setTimeout(() => {
      setResetManager(false)
    }, 0)
    dispatch(
      highValueLeadAction.loadHighValueLead({
        page: 1,
        limit: 50,
      })
    )
  }

  let slNo = 0
  const manageHighValueLeadTable = !isEmpty(highValueLead_details)
    ? highValueLead_details.data.map((data, index) => {
        slNo = slNo + 1

        var leadDate = !isEmpty(data.leadDate)
          ? moment(data.leadDate)
              .subtract(5, "hours")
              .subtract(30, "minutes")
              .format(`${dateFormate} hh:mm A`)
          : []

        //Sales Manager Name
        const salesManager =
          !isEmpty(data) && data.empCode && data.name
            ? `${data.empCode} - ${data.name}`
            : data.name
        //Open status
        const openData = !isEmpty(data.subStatus)
          ? data.subStatus.filter((status) => status.leadSubStatus == "Open")
          : []
        console.log(openData, "openData")

        const openDataDetails =
          !isEmpty(openData) && openData.length > 0 ? openData[0].budget : 0
        const openLeadDetails =
          !isEmpty(openData) && openData.length > 0
            ? openData[0].leadId.length
            : 0
        //Booked status
        const bookedData = !isEmpty(data.subStatus)
          ? data.subStatus.filter((status) => status.leadSubStatus == "Booked")
          : []
        console.log(bookedData, "bookedData")

        const bookedDataDetails =
          !isEmpty(bookedData) && bookedData.length > 0
            ? bookedData[0].budget
            : 0
        const bookedLeadDetails =
          !isEmpty(bookedData) && bookedData.length > 0
            ? bookedData[0].leadId.length
            : 0
        //Followup status
        const followupData = !isEmpty(data.subStatus)
          ? data.subStatus.filter(
              (status) => status.leadSubStatus == "Followup"
            )
          : []
        console.log(followupData, "followupData")

        const followupDataDetails =
          !isEmpty(followupData) && followupData.length > 0
            ? followupData[0].budget
            : 0
        const followupLeadDetails =
          !isEmpty(followupData) && followupData.length > 0
            ? followupData[0].leadId.length
            : 0
        //TIme status
        const timeData = !isEmpty(data.subStatus)
          ? data.subStatus.filter(
              (status) => status.leadSubStatus == "Need Time To Think"
            )
          : []
        console.log(timeData, "timeData")

        const timeDataDetails =
          !isEmpty(timeData) && timeData.length > 0 ? timeData[0].budget : 0
        const timeLeadDetails =
          !isEmpty(timeData) && timeData.length > 0
            ? timeData[0].leadId.length
            : 0
        //Non Contactable status
        const nonContactable = !isEmpty(data.subStatus)
          ? data.subStatus.filter(
              (status) => status.leadSubStatus == "Non Contactable"
            )
          : []
        console.log(nonContactable, "nonContactable")

        const nonContactableDetails =
          !isEmpty(nonContactable) && nonContactable.length > 0
            ? nonContactable[0].budget
            : 0
        const nonContactableLeadDetails =
          !isEmpty(nonContactable) && nonContactable.length > 0
            ? nonContactable[0].leadId.length
            : 0
        //Already Booked status
        const alreadyBooked = !isEmpty(data.subStatus)
          ? data.subStatus.filter(
              (status) =>
                status.leadSubStatus == "Not Interested & Already Booked"
            )
          : []
        console.log(alreadyBooked, "alreadyBooked")

        const alreadyBookedDetails =
          !isEmpty(alreadyBooked) && alreadyBooked.length > 0
            ? alreadyBooked[0].budget
            : 0
        const alreadyBookedLeadDetails =
          !isEmpty(alreadyBooked) && alreadyBooked.length > 0
            ? alreadyBooked[0].leadId.length
            : 0
        //Not Booked status
        const notBooked = !isEmpty(data.subStatus)
          ? data.subStatus.filter(
              (status) => status.leadSubStatus == "Not Interested & Not Booked"
            )
          : []
        console.log(notBooked, "notBooked")

        const notBookedDetails =
          !isEmpty(notBooked) && notBooked.length > 0 ? notBooked[0].budget : 0
        const notBookedLeadDetails =
          !isEmpty(notBooked) && notBooked.length > 0
            ? notBooked[0].leadId.length
            : 0
        //Yet action status
        const yetAction = !isEmpty(data.subStatus)
          ? data.subStatus.filter(
              (status) => status.leadSubStatus == "Yet To Action"
            )
          : []
        console.log(yetAction, "yetAction")

        const yetActionDetails =
          !isEmpty(yetAction) && yetAction.length > 0 ? yetAction[0].budget : 0
        const yetActionLeadDetails =
          !isEmpty(yetAction) && yetAction.length > 0
            ? yetAction[0].leadId.length
            : 0
        //Confirm status
        const confirmData = !isEmpty(data.subStatus)
          ? data.subStatus.filter(
              (status) => status.leadSubStatus == "Almost Confirm"
            )
          : []
        console.log(confirmData, "confirmData")

        const confirmDataDetails =
          !isEmpty(confirmData) && confirmData.length > 0
            ? confirmData[0].budget
            : 0
        const confirmLeadDetails =
          !isEmpty(confirmData) && confirmData.length > 0
            ? confirmData[0].leadId.length
            : 0
        //Rejected status
        const rejectedData = !isEmpty(data.subStatus)
          ? data.subStatus.filter(
              (status) => status.leadSubStatus == "Rejected"
            )
          : []
        console.log(rejectedData, "rejectedData")

        const rejectedDataDetails =
          !isEmpty(rejectedData) && rejectedData.length > 0
            ? rejectedData[0].budget
            : 0
        const rejectedLeadDetails =
          !isEmpty(rejectedData) && rejectedData.length > 0
            ? rejectedData[0].leadId.length
            : 0

        //GrandTotal
        const grandTotalValueData = parseInt(
          openDataDetails +
            followupDataDetails +
            timeDataDetails +
            nonContactableDetails +
            alreadyBookedDetails +
            yetActionDetails +
            rejectedDataDetails +
            confirmDataDetails +
            bookedDataDetails
        )
        const grandTotalCountData = parseInt(
          openLeadDetails +
            followupLeadDetails +
            timeLeadDetails +
            nonContactableLeadDetails +
            alreadyBookedLeadDetails +
            yetActionLeadDetails +
            rejectedLeadDetails +
            confirmLeadDetails +
            bookedLeadDetails
        )
        console.log(grandTotalValueData, "grandTotalValueData")
        console.log(grandTotalCountData, "grandTotalCountData")
        console.log(bookedLeadDetails, "bookedLeadDetails")
        return {
          _id: data.leadId,
          leadId: data.leadId,
          sNo: slNo,
          managerName: salesManager,
          budget: data.budget ? data.budget : "--",
          subStatus: data.subStatus,
          open: leadMode === "Count" ? openLeadDetails : openDataDetails,
          openLead: openLeadDetails,
          booked: leadMode === "Count" ? bookedLeadDetails : bookedDataDetails,
          bookedLead: bookedLeadDetails,
          followup:
            leadMode === "Count" ? followupLeadDetails : followupDataDetails,
          followupLead: followupLeadDetails,
          time: leadMode === "Count" ? timeLeadDetails : timeDataDetails,
          timeLead: timeLeadDetails,
          nonContactable:
            leadMode === "Count"
              ? nonContactableLeadDetails
              : nonContactableDetails,
          nonContactableLead: nonContactableLeadDetails,
          alreadyBooked:
            leadMode === "Count"
              ? alreadyBookedLeadDetails
              : alreadyBookedDetails,
          alreadyBookedLead: alreadyBookedLeadDetails,
          notBooked:
            leadMode === "Count" ? notBookedLeadDetails : notBookedDetails,
          notBookedLead: notBookedLeadDetails,
          yetAction:
            leadMode === "Count" ? yetActionLeadDetails : yetActionDetails,
          yetActionLead: yetActionLeadDetails,
          almostConfirm:
            leadMode === "Count" ? confirmLeadDetails : confirmDataDetails,
          confirmLead: confirmLeadDetails,
          rejected:
            leadMode === "Count" ? rejectedLeadDetails : rejectedDataDetails,
          rejectedLead: rejectedLeadDetails,
          grandTotal:
            leadMode === "Count" ? grandTotalCountData : grandTotalValueData,
          grandTotalCount: grandTotalCountData,
          leadDate: data.leadDate ? leadDate : "--",
          key: index,
        }
      })
    : []

  //pagination table data columns
  const columns = [
    {
      dataField: "managerName",
      text: "Sales Manager",
      hidden: false,
      style: {
        color: "#E40D8C",
      },
      headerStyle: {
        minWidth: "240px",
      },
      footer: "Grand Total",
    },
    {
      dataField: "open",
      text: "Open",
      hidden: false,

      headerStyle: {
        minWidth: "120px",
      },
      footer: (columnData) =>
        !isEmpty(columnData) && columnData.length > 0
          ? columnData.reduce((acc, item) => {
              console.log(acc, item, "item values")
              // const additionData =
              const data =
                acc != undefined && item != undefined ? parseInt(acc + item) : 0
              return data
            })
          : 0,
    },
    {
      dataField: "almostConfirm",
      text: "Almost Confirm",
      hidden: false,

      headerStyle: {
        minWidth: "150px",
      },
      style: {
        textTransform: "uppercase",
      },
      footer: (columnData) =>
        !isEmpty(columnData) && columnData.length > 0
          ? columnData.reduce((acc, item) => {
              console.log(acc, item, "item values")
              const data =
                acc != undefined && item != undefined ? parseInt(acc + item) : 0
              return data
            })
          : 0,
    },
    {
      dataField: "booked",
      text: "Booked",
      hidden: false,
      headerStyle: {
        minWidth: "160px",
      },
      footer: (columnData) =>
        !isEmpty(columnData) && columnData.length > 0
          ? columnData.reduce((acc, item) => {
              console.log(acc, item, "item values")
              const data =
                acc != undefined && item != undefined ? parseInt(acc + item) : 0
              return data
            })
          : 0,
    },
    {
      dataField: "followup",
      text: "Followup",
      hidden: false,
      headerStyle: {
        minWidth: "160px",
      },
      footer: (columnData) =>
        !isEmpty(columnData) && columnData.length > 0
          ? columnData.reduce((acc, item) => {
              console.log(acc, item, "item values")
              const data =
                acc != undefined && item != undefined ? parseInt(acc + item) : 0
              return data
            })
          : 0,
    },
    {
      dataField: "time",
      text: "Need Time To Think",
      hidden: false,
      headerStyle: {
        minWidth: "160px",
      },
      footer: (columnData) =>
        !isEmpty(columnData) && columnData.length > 0
          ? columnData.reduce((acc, item) => {
              console.log(acc, item, "item values")
              const data =
                acc != undefined && item != undefined ? parseInt(acc + item) : 0
              return data
            })
          : 0,
    },
    // {
    //   dataField: "noResponse",
    //   text: "No Response",
    //   hidden: false,
    //   headerStyle: {
    //     minWidth: "120px",
    //   },
    //   footer: (columnData) =>
    //     !isEmpty(columnData) && columnData.length > 0
    //       ? columnData.reduce((acc, item) => {
    //           console.log(acc, item, "item values")
    //           const data =
    //             acc != undefined && item != undefined ? parseInt(acc + item) : 0
    //           return data
    //         })
    //       : 0,
    // },
    {
      dataField: "nonContactable",
      text: "Non Contactable",
      hidden: false,
      headerStyle: {
        minWidth: "150px",
      },
      footer: (columnData) =>
        !isEmpty(columnData) && columnData.length > 0
          ? columnData.reduce((acc, item) => {
              console.log(acc, item, "item values")
              const data =
                acc != undefined && item != undefined ? parseInt(acc + item) : 0
              return data
            })
          : 0,
    },
    {
      dataField: "alreadyBooked",
      text: "Not Interested & Already Booked",
      hidden: false,
      headerStyle: {
        minWidth: "240px",
      },
      footer: (columnData) =>
        !isEmpty(columnData) && columnData.length > 0
          ? columnData.reduce((acc, item) => {
              console.log(acc, item, "item values")
              const data =
                acc != undefined && item != undefined ? parseInt(acc + item) : 0
              return data
            })
          : 0,
    },
    {
      dataField: "notBooked",
      text: "Not Interested & Not Booked",
      hidden: false,
      headerStyle: {
        minWidth: "220px",
      },
      footer: (columnData) =>
        !isEmpty(columnData) && columnData.length > 0
          ? columnData.reduce((acc, item) => {
              console.log(acc, item, "item values")
              const data =
                acc != undefined && item != undefined ? parseInt(acc + item) : 0
              return data
            })
          : 0,
    },
    {
      dataField: "rejected",
      text: "Rejected",
      hidden: false,
      headerStyle: {
        minWidth: "120px",
      },
      footer: (columnData) =>
        !isEmpty(columnData) && columnData.length > 0
          ? columnData.reduce((acc, item) => {
              console.log(acc, item, "item values")
              const data =
                acc != undefined && item != undefined ? parseInt(acc + item) : 0
              return data
            })
          : 0,
    },
    {
      dataField: "yetAction",
      text: "Yet To Action",
      hidden: false,
      headerStyle: {
        minWidth: "140px",
      },
      footer: (columnData) =>
        !isEmpty(columnData) && columnData.length > 0
          ? columnData.reduce((acc, item) => {
              console.log(acc, item, "item values")
              const data =
                acc != undefined && item != undefined ? parseInt(acc + item) : 0
              return data
            })
          : 0,
    },
    {
      dataField: "grandTotal",
      text: "Grand Total",
      hidden: false,
      headerStyle: {
        minWidth: "140px",
      },
      footer: (columnData) =>
        !isEmpty(columnData) && columnData.length > 0
          ? columnData.reduce((acc, item) => {
              console.log(acc, item, "item values")
              const data =
                acc != undefined && item != undefined ? parseInt(acc + item) : 0
              return data
            })
          : 0,
    },
  ]

  //Columns section end

  const [loading, setLoading] = useState(false)

  //Search filter
  const [searchFilter, setSearchFilter] = useState(false)
  const handleClick = (e) => {
    e.preventDefault()
    setSearchFilter(true)
    setLoading(true)
    dispatch(
      highValueLeadAction.loadHighValueLead({
        searchFilter: searchInput,
        page: pageChange ? pageCount : 1,
        limit: 50,
      })
    )
    setTimeout(() => {
      setSearchFilter(false)
      setLoading(false)
    }, 800)
  }

  //Pagination Component
  const downloadFile = ({ data, fileName, fileType }) => {
    const blob = new Blob([data], { type: fileType })

    const a = document.createElement("a")
    a.download = fileName
    a.href = window.URL.createObjectURL(blob)
    const clickEvt = new MouseEvent("click", {
      view: window,
      bubbles: true,
      cancelable: true,
    })
    a.dispatchEvent(clickEvt)
    a.remove()
  }

  const exportToCsv = () => {
    var searchCompany = companies && companies ? companies.value : ""
    var searchBranch = branches && branches ? branches.value : ""
    var searchEvent = event && event ? event.value : ""
    var searchLeadStatus = leadStatus && leadStatus ? leadStatus.value : ""
    var searchLeadSubStatus =
      leadSubStatus && leadSubStatus ? leadSubStatus.value : ""
    var searchManagerName = managerName && managerName ? managerName.value : ""
    var searchFromDate =
      followupData && followupData.fromDate
        ? moment(followupData.fromDate).format("YYYY-MM-DD")
        : ""
    var searchToDate =
      followupData && followupData.toDate
        ? moment(followupData.toDate).format("YYYY-MM-DD")
        : ""
    var searchSalesUrge = salesUrge && salesUrge ? salesUrge.value : ""
    var searchvalue = {}
    // searchvalue.page = pageChange ? pageCount : 1
    // searchvalue.limit = 50
    if (searchCompany) {
      searchvalue.companyId = searchCompany
    }
    if (searchBranch) {
      searchvalue.branchId = searchBranch
    }
    if (searchEvent) {
      searchvalue.eventId = searchEvent
    }
    if (searchLeadStatus) {
      searchvalue.leadStatus = searchLeadStatus
    }
    if (searchLeadSubStatus) {
      searchvalue.leadSubStatus = searchLeadSubStatus
    }
    if (searchManagerName) {
      searchvalue.assignEmp = searchManagerName
    }
    if (searchFromDate) {
      searchvalue.fromDate = searchFromDate
    }
    if (searchToDate) {
      searchvalue.toDate = searchToDate
    }
    if (searchSalesUrge) {
      searchvalue.salesUrge = searchSalesUrge
    }

    setPageLoad(!pageLoad)
    console.log("searchCompany", searchvalue)
    setDownloadLoading(true)
    api
      .post(`/get_high_value_report_employee_export_excel`, searchvalue)
      .then((response) => {
        const manageHighValueLeadExportDataTable = !isEmpty(response.data.data)
          ? response.data.data.map((data, index) => {
              // serialNo = serialNo + 1
              var leadDate = !isEmpty(data.leadDate)
                ? moment(data.leadDate)
                    .subtract(5, "hours")
                    .subtract(30, "minutes")
                    .format(`${dateFormate} hh:mm A`)
                : []

              //Sales Manager Name
              const salesManager =
                !isEmpty(data) && data.empCode && data.name
                  ? `${data.empCode} - ${data.name}`
                  : data.name
              //Open status
              const openData = !isEmpty(data.subStatus)
                ? data.subStatus.filter(
                    (status) => status.leadSubStatus == "Open"
                  )
                : []
              console.log(openData, "openData")

              const columnOpenBudgetDetails =
                isEmpty(openData) && openData.length > 0
                  ? openData.map((item) => {
                      console.log(item, "columnOpenBudgetDetails values")
                      const data =
                        !isEmpty(item) && item != undefined
                          ? // ? parseInt(acc + item)
                            parseInt(item.budget + item.budget)
                          : 0
                      return data
                    })
                  : 0
              const columnOpenLeadDetails =
                isEmpty(openData) && openData.length > 0
                  ? openData.map((item) => {
                      console.log(item, "columnOpenLeadDetails values")
                      const data =
                        !isEmpty(item) && item != undefined
                          ? // ? parseInt(item.budget + item.budget)
                            parseInt(item.leadId.length + item.leadId.length)
                          : 0
                      return data
                    })
                  : 0
              console.log(columnOpenBudgetDetails, "columnOpenBudgetDetails")
              console.log(columnOpenLeadDetails, "columnOpenLeadDetails")
              const openDataDetails =
                !isEmpty(openData) && openData.length > 0
                  ? openData[0].budget
                  : 0
              const openLeadDetails =
                !isEmpty(openData) && openData.length > 0
                  ? openData[0].leadId.length
                  : 0
              //Booked status
              const bookedData = !isEmpty(data.subStatus)
                ? data.subStatus.filter(
                    (status) => status.leadSubStatus == "Booked"
                  )
                : []
              console.log(bookedData, "bookedData")

              const bookedDataDetails =
                !isEmpty(bookedData) && bookedData.length > 0
                  ? bookedData[0].budget
                  : 0
              const bookedLeadDetails =
                !isEmpty(bookedData) && bookedData.length > 0
                  ? bookedData[0].leadId.length
                  : 0
              //Followup status
              const followupData = !isEmpty(data.subStatus)
                ? data.subStatus.filter(
                    (status) => status.leadSubStatus == "Followup"
                  )
                : []
              console.log(followupData, "followupData")

              const followupDataDetails =
                !isEmpty(followupData) && followupData.length > 0
                  ? followupData[0].budget
                  : 0
              const followupLeadDetails =
                !isEmpty(followupData) && followupData.length > 0
                  ? followupData[0].leadId.length
                  : 0
              //TIme status
              const timeData = !isEmpty(data.subStatus)
                ? data.subStatus.filter(
                    (status) => status.leadSubStatus == "Need Time To Think"
                  )
                : []
              console.log(timeData, "timeData")

              const timeDataDetails =
                !isEmpty(timeData) && timeData.length > 0
                  ? timeData[0].budget
                  : 0
              const timeLeadDetails =
                !isEmpty(timeData) && timeData.length > 0
                  ? timeData[0].leadId.length
                  : 0
              //Non Contactable status
              const nonContactable = !isEmpty(data.subStatus)
                ? data.subStatus.filter(
                    (status) => status.leadSubStatus == "Non Contactable"
                  )
                : []
              console.log(nonContactable, "nonContactable")

              const nonContactableDetails =
                !isEmpty(nonContactable) && nonContactable.length > 0
                  ? nonContactable[0].budget
                  : 0
              const nonContactableLeadDetails =
                !isEmpty(nonContactable) && nonContactable.length > 0
                  ? nonContactable[0].leadId.length
                  : 0
              //Already Booked status
              const alreadyBooked = !isEmpty(data.subStatus)
                ? data.subStatus.filter(
                    (status) =>
                      status.leadSubStatus == "Not Interested & Already Booked"
                  )
                : []
              console.log(alreadyBooked, "alreadyBooked")

              const alreadyBookedDetails =
                !isEmpty(alreadyBooked) && alreadyBooked.length > 0
                  ? alreadyBooked[0].budget
                  : 0
              const alreadyBookedLeadDetails =
                !isEmpty(alreadyBooked) && alreadyBooked.length > 0
                  ? alreadyBooked[0].leadId.length
                  : 0
              //Not Booked status
              const notBooked = !isEmpty(data.subStatus)
                ? data.subStatus.filter(
                    (status) =>
                      status.leadSubStatus == "Not Interested & Not Booked"
                  )
                : []
              console.log(notBooked, "notBooked")

              const notBookedDetails =
                !isEmpty(notBooked) && notBooked.length > 0
                  ? notBooked[0].budget
                  : 0
              const notBookedLeadDetails =
                !isEmpty(notBooked) && notBooked.length > 0
                  ? notBooked[0].leadId.length
                  : 0
              //Yet action status
              const yetAction = !isEmpty(data.subStatus)
                ? data.subStatus.filter(
                    (status) => status.leadSubStatus == "Yet To Action"
                  )
                : []
              console.log(yetAction, "yetAction")

              const yetActionDetails =
                !isEmpty(yetAction) && yetAction.length > 0
                  ? yetAction[0].budget
                  : 0
              const yetActionLeadDetails =
                !isEmpty(yetAction) && yetAction.length > 0
                  ? yetAction[0].leadId.length
                  : 0
              //Confirm status
              const confirmData = !isEmpty(data.subStatus)
                ? data.subStatus.filter(
                    (status) => status.leadSubStatus == "Almost Confirm"
                  )
                : []
              console.log(confirmData, "confirmData")

              const confirmDataDetails =
                !isEmpty(confirmData) && confirmData.length > 0
                  ? confirmData[0].budget
                  : 0
              const confirmLeadDetails =
                !isEmpty(confirmData) && confirmData.length > 0
                  ? confirmData[0].leadId.length
                  : 0
              //Rejected status
              const rejectedData = !isEmpty(data.subStatus)
                ? data.subStatus.filter(
                    (status) => status.leadSubStatus == "Rejected"
                  )
                : []
              console.log(rejectedData, "rejectedData")

              const rejectedDataDetails =
                !isEmpty(rejectedData) && rejectedData.length > 0
                  ? rejectedData[0].budget
                  : 0
              const rejectedLeadDetails =
                !isEmpty(rejectedData) && rejectedData.length > 0
                  ? rejectedData[0].leadId.length
                  : 0

              //GrandTotal
              const grandTotalValueData = parseInt(
                openDataDetails +
                  followupDataDetails +
                  timeDataDetails +
                  nonContactableDetails +
                  alreadyBookedDetails +
                  yetActionDetails +
                  rejectedDataDetails +
                  confirmDataDetails +
                  bookedDataDetails
              )
              const grandTotalCountData = parseInt(
                openLeadDetails +
                  followupLeadDetails +
                  timeLeadDetails +
                  nonContactableLeadDetails +
                  alreadyBookedLeadDetails +
                  yetActionLeadDetails +
                  rejectedLeadDetails +
                  confirmLeadDetails +
                  bookedLeadDetails
              )
              console.log(grandTotalValueData, "grandTotalValueData")
              console.log(grandTotalCountData, "grandTotalCountData")
              console.log(bookedLeadDetails, "bookedLeadDetails")
              return {
                _id: data.leadId,
                leadId: data.leadId,
                sNo: slNo,
                managerName: salesManager,
                budget: data.budget ? data.budget : "--",
                subStatus: data.subStatus,
                open: leadMode === "Count" ? openLeadDetails : openDataDetails,
                openLead: openLeadDetails,
                booked:
                  leadMode === "Count" ? bookedLeadDetails : bookedDataDetails,
                bookedLead: bookedLeadDetails,
                followup:
                  leadMode === "Count"
                    ? followupLeadDetails
                    : followupDataDetails,
                followupLead: followupLeadDetails,
                time: leadMode === "Count" ? timeLeadDetails : timeDataDetails,
                timeLead: timeLeadDetails,
                nonContactable:
                  leadMode === "Count"
                    ? nonContactableLeadDetails
                    : nonContactableDetails,
                nonContactableLead: nonContactableLeadDetails,
                alreadyBooked:
                  leadMode === "Count"
                    ? alreadyBookedLeadDetails
                    : alreadyBookedDetails,
                alreadyBookedLead: alreadyBookedLeadDetails,
                notBooked:
                  leadMode === "Count"
                    ? notBookedLeadDetails
                    : notBookedDetails,
                notBookedLead: notBookedLeadDetails,
                yetAction:
                  leadMode === "Count"
                    ? yetActionLeadDetails
                    : yetActionDetails,
                yetActionLead: yetActionLeadDetails,
                almostConfirm:
                  leadMode === "Count"
                    ? confirmLeadDetails
                    : confirmDataDetails,
                confirmLead: confirmLeadDetails,
                rejected:
                  leadMode === "Count"
                    ? rejectedLeadDetails
                    : rejectedDataDetails,
                rejectedLead: rejectedLeadDetails,
                grandTotal:
                  leadMode === "Count"
                    ? grandTotalCountData
                    : grandTotalValueData,
                grandTotalCount: grandTotalCountData,
                leadDate: data.leadDate ? leadDate : "--",
                key: index,
              }
            })
          : []
        setTimeout(() => {
          let headerData = [
            "Sales Manager,Open,Almost Confirm, Booked,Followup,Need Time To Think, Non Contactable,Not Interested & Already Booked,Not Interested & Not Booked,Rejected,Yet To Action,Grand Total",
          ]

          let usersCsv =
            !isEmpty(manageHighValueLeadExportDataTable) &&
            manageHighValueLeadExportDataTable.reduce((acc, user) => {
              const {
                managerName,
                open,
                almostConfirm,
                booked,
                followup,
                time,
                nonContactable,
                alreadyBooked,
                notBooked,
                rejected,
                yetAction,
                grandTotal,
              } = user
              acc.push([
                managerName,
                open,
                almostConfirm,
                booked,
                followup,
                time,
                nonContactable,
                alreadyBooked,
                notBooked,
                rejected,
                yetAction,
                grandTotal,
              ])

              console.log("test", acc)
              return acc
            }, [])
          console.log(usersCsv, "usersCsv")
          downloadFile({
            data: [...headerData, ...usersCsv].join("\n"),
            fileName: "HighValueLeadSummary.csv",
            fileType: "text/csv",
          })
          setDownloadLoading(false)
        }, 1500)
        return response.data
      })
      .catch((error) => {
        Promise.reject(error)
        setDownloadLoading(false)
      })
  }
  const RemotePagination = ({
    data,
    page,
    // sort,
    sizePerPage,
    onTableChange,
    totalSize,
  }) => (
    <div>
      <PaginationProvider
        pagination={paginationFactory({
          custom: true,
          page,
          // sort,
          sizePerPage,
          totalSize,
        })}
      >
        {({ paginationProps, paginationTableProps }) => (
          <div>
            <ToolkitProvider
              keyField="_id"
              data={data}
              columns={columns}
              search
              exportCSV
            >
              {() => (
                <div>
                  <Col md="12" xl="12" lg="12" sm="12" xs="12">
                    <Row className="d-flex flex-row">
                      <Col className="mb-3" md="4"></Col>

                      <Col
                        md="8"
                        style={{ marginBottom: "20px", marginTop: "-41px" }}
                      >
                        <div
                          style={{
                            float: "right",
                            marginRight: "10px",
                          }}
                        >
                          <Button
                            className="btn btn-primary"
                            onClick={exportToCsv}
                            id="download"
                            style={{
                              backgroundColor: "#e40d8c",
                              color: "white",
                              border: "none",
                            }}
                          >
                            Download
                          </Button>
                        </div>
                      </Col>

                      <Col>
                        <BootstrapTable
                          remote
                          // {...props.baseProps}
                          keyField="_id"
                          data={data}
                          id="ImportTable"
                          columns={columns}
                          responsive
                          striped={true}
                          bordered={true}
                          footerClasses="high-value-grandtotal"
                          onTableChange={onTableChange}
                          {...paginationTableProps}
                        />
                      </Col>
                    </Row>
                    <Row
                      style={{ marginTop: "5px" }}
                      className="align-items-md-center mt-30"
                    >
                      <Col className="inner-custom-pagination d-flex">
                        <div className="d-inline d-flex flex-row">
                          <SizePerPageDropdownStandalone {...paginationProps} />
                          <div
                            style={{
                              fontSize: "14px",
                              marginTop: "8px",
                              marginLeft: "4px",
                            }}
                          >
                            <PaginationTotalStandalone {...paginationProps} />
                          </div>
                        </div>
                        <div
                          className="text-md-right ms-auto"
                          style={{ zIndex: 0 }}
                        >
                          <PaginationListStandalone {...paginationProps} />
                        </div>
                      </Col>
                    </Row>
                  </Col>
                </div>
              )}
            </ToolkitProvider>
          </div>
        )}
      </PaginationProvider>
    </div>
  )
  const [pageLoad, setPageLoad] = useState(false)
  const [state, setState] = useState({
    sizePerPage: 50,
    page: 1,
    totalSize: highValueLead_details.length,
    data:
      !isEmpty(highValueLead_details) && highValueLead_details.length > 0
        ? highValueLead_details.slice(0, 50)
        : [],
  })
  const { sizePerPage, page } = state

  //Table Change

  const handleTableChange = (type, { page, currentIndex, sizePerPage }) => {
    setPageCount(page)
    setPageChange(true)
    setPageLoad(!pageLoad)
    console.log(page, "page")
    let result =
      !isEmpty(highValueLead_details) && highValueLead_details.length > 0
        ? highValueLead_details
        : []
    if (
      !isEmpty(companies) ||
      !isEmpty(branches) ||
      !isEmpty(followupData.fromDate) ||
      !isEmpty(followupData.toDate) ||
      !isEmpty(event) ||
      !isEmpty(leadStatus) ||
      !isEmpty(leadSubStatus) ||
      !isEmpty(managerName) ||
      !isEmpty(salesUrge)
    ) {
      var searchCompany = companies && companies ? companies.value : ""
      var searchBranch = branches && branches ? branches.value : ""
      var searchEvent = event && event ? event.value : ""
      var searchLeadStatus = leadStatus && leadStatus ? leadStatus.value : ""
      var searchLeadSubStatus =
        leadSubStatus && leadSubStatus ? leadSubStatus.value : ""
      var searchManagerName =
        managerName && managerName ? managerName.value : ""
      var searchSalesUrge = salesUrge && salesUrge ? salesUrge.value : ""
      var searchFromDate =
        followupData && followupData.fromDate
          ? moment(followupData.fromDate).format("YYYY-MM-DD")
          : ""
      var searchToDate =
        followupData && followupData.toDate
          ? moment(followupData.toDate).format("YYYY-MM-DD")
          : ""

      var searchvalue = {}
      searchvalue.page = pageChange ? pageCount : 1
      searchvalue.limit = 50
      if (searchCompany) {
        searchvalue.companyId = searchCompany
      }
      if (searchBranch) {
        searchvalue.branchId = searchBranch
      }
      if (searchEvent) {
        searchvalue.eventId = searchEvent
      }
      if (searchLeadStatus) {
        searchvalue.leadStatus = searchLeadStatus
      }
      if (searchLeadSubStatus) {
        searchvalue.leadSubStatus = searchLeadSubStatus
      }
      if (searchManagerName) {
        searchvalue.assignEmp = searchManagerName
      }
      if (searchFromDate) {
        searchvalue.fromDate = searchFromDate
      }
      if (searchToDate) {
        searchvalue.toDate = searchToDate
      }
      if (searchSalesUrge) {
        searchvalue.salesUrge = searchSalesUrge
      }

      setPageLoad(!pageLoad)
      console.log("searchCompany", searchvalue)
      setLoading(true)
      specificDispatch(highValueLeadAction.loadHighValueLead(searchvalue))
    } else {
      dispatch(
        highValueLeadAction.loadHighValueLead({
          page: page,
          limit: sizePerPage,
        })
      )
      setLoading(true)
      setPageLoad(!pageLoad)
    }
    // setPageCount(page)
    setTimeout(() => {
      setLoading(false)
    }, 2000)

    setState(() => ({
      page,
      data: result.slice(currentIndex, currentIndex + sizePerPage),
      totalSize: result.length,
      sizePerPage,
    }))
  }

  return (
    <React.Fragment>
      <div className="page-content">
        <MetaTags>
          <title>{title} | Zero Gravity CRM</title>
        </MetaTags>
        <Container fluid>
          {/* Render Breadcrumb */}
          <Breadcrumbs title={"Sales"} breadcrumbItem={title} />

          <Row>
            <Col xs={12}>
              <Card>
                <CardBody>
                  <form>
                    <Row>
                      <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                        <div className="d-flex justify-content-between">
                          <Label className={"form-label"} htmlFor={"Company"}>
                            {"Company"}
                          </Label>
                        </div>

                        <Select
                          type="text"
                          name="company"
                          value={companies}
                          onChange={(e) => setCompanies(e)}
                          options={
                            recordsMetaData
                              ? recordsMetaData.companyOptions
                              : []
                          }
                          placeholder="Select Company"
                          classNamePrefix="select2-selection"
                        />
                      </Col>
                      <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                        <div className="d-flex justify-content-between">
                          <Label className={"form-label"} htmlFor={"Branch"}>
                            {"Branch"}
                          </Label>
                        </div>
                        <Select
                          type="text"
                          name="branch"
                          value={branches}
                          onChange={(e) => setBranches(e)}
                          options={branchOptions}
                          placeholder="Select Branch"
                          classNamePrefix="select2-selection"
                        />
                      </Col>
                      <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                        <div className="d-flex justify-content-between">
                          <Label className={"form-label"}>{"Sales Urge"}</Label>
                        </div>
                        <Select
                          type="text"
                          name="salesUgre"
                          value={salesUrge}
                          onChange={(e) => setSalesUrge(e)}
                          options={[
                            { label: "Hot", value: "hot" },
                            { label: "Warm", value: "warm" },
                            { label: "Cold", value: "cold" },
                          ]}
                          placeholder="Select Sales Urge"
                          classNamePrefix="select2-selection"
                        />
                      </Col>
                      <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                        <div className="d-flex justify-content-between">
                          <Label className="form-label" htmlFor={"From Date"}>
                            {"Manager Name"}
                          </Label>
                        </div>
                        <ReactSearchAutocomplete
                          name="managerName"
                          key={resetManager}
                          items={employeeOptions}
                          value={managerName ? managerName : ""}
                          type="autoComplete"
                          resultStringKeyName="label"
                          showIcon={false}
                          onSelect={(e) => setManagerName(e)}
                          onChange={(e) => setManagerName(e.target.value)}
                          placeholder="Enter Manager Name"
                          fuseOptions={fuseOptions} // Search on both fields
                          styling={{
                            height: "34px",
                            border: "1px solid #ced4da",
                            borderRadius: "4px",
                            backgroundColor: "white",
                            boxShadow: "none",
                            hoverBackgroundColor: "#E40D8C",
                            color: "black",
                            fontSize: "12px",
                            fontFamily: "Courier",
                            iconColor: "green",
                            clearIconMargin: "3px 8px 0 0",
                            zIndex: 10,
                          }}
                        />
                      </Col>

                      <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                        <div className="d-flex justify-content-between">
                          <Label className={"form-label"}>
                            {"Lead Status"}
                          </Label>
                        </div>
                        <Select
                          name="leadStatus"
                          value={leadStatus}
                          onChange={(e) => setLeadStatus(e)}
                          options={
                            recordsMetaData
                              ? recordsMetaData.processStatusOptions
                              : []
                          }
                          placeholder="Select Lead Status"
                          classNamePrefix="select2-selection"
                        />
                      </Col>
                      <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                        <div className="d-flex justify-content-between">
                          <Label className={"form-label"}>
                            {"Lead Sub Status"}
                          </Label>
                        </div>
                        <Select
                          name="leadSubStatus"
                          value={leadSubStatus}
                          onChange={(e) => setLeadSubStatus(e)}
                          options={leadSubStatusOptions}
                          placeholder="Select Lead Sub Status"
                          classNamePrefix="select2-selection"
                        />
                      </Col>
                      <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                        <div className="d-flex justify-content-between">
                          <Label className="form-label" htmlFor={"From Date"}>
                            {"From Date"}
                          </Label>
                        </div>
                        <Input
                          type="date"
                          placeholder="Select Date"
                          name="fromDate"
                          max={followupData.toDate}
                          value={followupData.fromDate}
                          onChange={(e) => handleChange(e)}
                        />
                      </Col>

                      <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                        <div className="d-flex justify-content-between">
                          <Label className="form-label" htmlFor={"To Date"}>
                            {"To Date"}
                          </Label>
                        </div>
                        <Input
                          type="date"
                          placeholder="Select Date"
                          name="toDate"
                          min={followupData.fromDate}
                          value={followupData.toDate}
                          onChange={(e) => handleChange(e)}
                        />
                      </Col>
                    </Row>
                    <Row>
                      <Col lg="12" md="12" sm="12" xs="12" className="mt-4">
                        <div
                          className="filter-buttons"
                          style={{ float: "right" }}
                        >
                          <Button
                            type="button"
                            onClick={() => resetForm()}
                            className="btn btn-danger btn-label simple-form-Reset-btn mx-2"
                          >
                            <i className="bx bx-reset bx-flip-horizontal label-icon"></i>
                            Reset
                          </Button>
                          <Button
                            type="submit"
                            onClick={(e) => handleFilter(e)}
                            className="btn btn-success btn-label simple-form-applyfilter-btn"
                          >
                            <i className="bx bx-filter-alt label-icon"></i>
                            {btnLoader && btnLoader ? (
                              <ButtonSpinner />
                            ) : (
                              "Apply Filter"
                            )}{" "}
                          </Button>
                        </div>
                      </Col>
                    </Row>
                  </form>
                </CardBody>
              </Card>
            </Col>
          </Row>
          {/*Table start*/}
          <Row>
            <Col md="12" lg="12" xl="12">
              <Card>
                <CardBody>
                  <Row>
                    <Col md="12" lg="12" xl="12">
                      <div
                        className="switch-field"
                        style={{ float: "right", marginBottom: "-2px" }}
                      >
                        <button
                          style={{
                            backgroundColor:
                              valueData == true ? "#e40d8c" : "#e4e4e4",
                            boxShadow:
                              valueData == true
                                ? "none"
                                : "inset 0 1px 3px rgba(0, 0, 0, 0.3), 0 1px rgba(255, 255, 255, 0.1)",
                            color: valueData == true ? "#ffffff" : "#000000",
                            border: "none",
                            cursor: "pointer",
                            padding: "6px 12px",
                            // borderRadius: "4px",
                          }}
                          onClick={() => {
                            setCounterData(false)
                            setValueData(true)
                            setLeadMode("Values")
                            setLoading(true)
                            setTimeout(() => {
                              setLoading(false)
                            }, 500)
                          }}
                        >
                          Values
                        </button>
                        <button
                          style={{
                            backgroundColor:
                              counterData == true ? "#e40d8c" : "#e4e4e4",
                            boxShadow:
                              counterData == true
                                ? "none"
                                : "inset 0 1px 3px rgba(0, 0, 0, 0.3), 0 1px rgba(255, 255, 255, 0.1)",
                            color: counterData == true ? "#ffffff" : "#000000",
                            border: "none",
                            cursor: "pointer",
                            padding: "6px 12px",
                            // borderRadius: "2px",
                          }}
                          onClick={() => {
                            setValueData(false)
                            setCounterData(true)
                            setLeadMode("Count")
                            setLoading(true)
                            setTimeout(() => {
                              setLoading(false)
                            }, 500)
                          }}
                        >
                          Count
                        </button>
                      </div>
                    </Col>
                  </Row>
                  <div
                    className="d-flex flex-row"
                    style={{ marginTop: "20px" }}
                  >
                    <div className="search-box me-2 mb-2 d-inline-block d-flex flex-row ">
                      <form onSubmit={handleClick} className="d-flex flex-row">
                        <div style={searchBtnStyle || null}>
                          <Input
                            type="text"
                            name="searchInput"
                            value={searchInput}
                            onChange={(e) => setSearchInput(e.target.value)}
                            className="form-control"
                            placeholder="Search"
                            style={{ position: "relative" }}
                          />
                          <i
                            className="bx bx-search-alt"
                            style={{
                              position: "absolute",
                              top: "82px",
                              left: "41px",
                              fontSize: "13px",
                            }}
                          />
                        </div>
                        <button
                          className="btn btn-success mx-2"
                          type="submit"
                          style={{
                            background: searchFilter ? "#2ca67a" : "",
                            color: searchFilter ? "#ffffff" : "",
                          }}
                          // onClick={(e) => handleClick()}
                        >
                          <i className="fas fa-search"></i>
                        </button>
                      </form>
                    </div>
                  </div>{" "}
                  <RemotePagination
                    data={manageHighValueLeadTable}
                    page={page}
                    sizePerPage={sizePerPage}
                    totalSize={
                      !isEmpty(highValueLead_details)
                        ? highValueLead_details.totalDataCount
                        : 0
                    }
                    onTableChange={handleTableChange}
                  />
                  {loading ? (
                    <Modal
                      show={loading}
                      style={{ width: "6.8%", margin: "18% 50%" }}
                    >
                      <Modal.Body>
                        <Spinner
                          as="span"
                          animation="grow"
                          size="lg"
                          role="status"
                          aria-hidden="true"
                          variant="success"
                          className="mx-2"
                          color="success"
                        />
                        {/* <span>Loading...</span> */}
                      </Modal.Body>
                    </Modal>
                  ) : (
                    ""
                  )}
                  {btnLoading ? (
                    <Modal
                      show={btnLoading}
                      style={{ width: "6.8%", margin: "18% 50%" }}
                    >
                      <Modal.Body>
                        <Spinner
                          as="span"
                          animation="grow"
                          size="lg"
                          role="status"
                          aria-hidden="true"
                          variant="success"
                          className="mx-2"
                          color="success"
                        />
                        {/* <span>Loading...</span> */}
                      </Modal.Body>
                    </Modal>
                  ) : (
                    ""
                  )}
                  {downloadLoading ? (
                    <Modal
                      show={downloadLoading}
                      style={{ width: "6.8%", margin: "18% 50%" }}
                    >
                      <Modal.Body>
                        <Spinner
                          as="span"
                          animation="grow"
                          size="lg"
                          role="status"
                          aria-hidden="true"
                          variant="success"
                          className="mx-2"
                          color="success"
                        />
                        {/* <span>Loading...</span> */}
                      </Modal.Body>
                    </Modal>
                  ) : (
                    ""
                  )}
                  {/* {columnModal && (
                    <Modal size="xl" show={columnModal}>
                      <Modal.Header
                        style={{
                          backgroundColor: "white",
                          color: "black",
                          fontSize: "16px",
                          fontWeight: "600",
                        }}
                      >
                        Edit Columns
                        <span>
                          <i
                            className="fa fa-times quote-close"
                            aria-hidden="true"
                            onClick={() => setColumnModal(false)}
                          ></i>
                        </span>
                      </Modal.Header>
                      <Modal.Body>
                        <Row>
                          <div>
                            <Input
                              type="checkbox"
                              checked={
                                selectedColumns.length === columns.length
                              }
                              onChange={(e) => handleSelectAllChange(e)}
                              style={{ width: "15px", height: "15px" }}
                            />
                            <Label
                              style={{ fontSize: "16px", marginLeft: "10px" }}
                            >
                              Select All
                            </Label>
                          </div>
                        </Row>
                        <Row>
                          <Col sm="12" md="6" lg="6" className="ml-4">
                            {oddColumnData.map((column) => (
                              <div
                                key={column.dataField}
                                className="d-flex flex-row"
                              >
                                <div className="form-check form-check-inline">
                                  <Input
                                    type="checkbox"
                                    value={column.dataField}
                                    checked={selectedColumns.includes(
                                      column.dataField
                                    )}
                                    onChange={(e) => handleCheckboxChange(e)}
                                    style={{ width: "15px", height: "15px" }}
                                  />
                                  <Label
                                    style={{
                                      fontSize: "16px",
                                      marginLeft: "10px",
                                    }}
                                  >
                                    {column.text}
                                  </Label>
                                </div>
                              </div>
                            ))}
                          </Col>
                          <Col sm="12" md="6" lg="6">
                            {evenColumnData.map((column) => (
                              <div
                                key={column.dataField}
                                className="d-flex flex-row"
                              >
                                <div className="form-check form-check-inline">
                                  <Input
                                    type="checkbox"
                                    value={column.dataField}
                                    checked={selectedColumns.includes(
                                      column.dataField
                                    )}
                                    onChange={(e) => handleCheckboxChange(e)}
                                    style={{ width: "15px", height: "15px" }}
                                  />
                                  <Label
                                    style={{
                                      fontSize: "16px",
                                      marginLeft: "10px",
                                    }}
                                  >
                                    {column.text}
                                  </Label>
                                </div>
                              </div>
                            ))}
                          </Col>
                        </Row>
                      </Modal.Body>

                      <Modal.Footer>
                        <p
                          className="text-decoration-underline text-info"
                          style={{ cursor: "pointer", fontSize: "16px" }}
                          onClick={handleRestoreToDefault}
                        >
                          Restore To Default
                        </p>
                        <Button
                          variant="secondary"
                          className="btn btn-danger"
                          data-bs-dismiss="modal"
                          onClick={() => {
                            setColumnModal(false)
                            setSelectedColumns(selectColumn)
                          }}
                        >
                          Close
                        </Button>
                        <Button
                          variant="primary"
                          className="btn btn-success"
                          onClick={() => handleSaveColumns()}
                        >
                          Submit
                        </Button>
                      </Modal.Footer>
                    </Modal>
                  )} */}
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
        <ToastContainer
          position="top-right"
          autoClose={1000}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
        />
      </div>
    </React.Fragment>
  )
}

HighValueLeadSummary.propTypes = {
  dispatch: PropTypes.func,
  recordsMetaData: PropTypes.array,
  searchProps: PropTypes.func,
  onSearch: PropTypes.func,
  onExport: PropTypes.func,
  baseProps: PropTypes.any,
  searchBtnStyle: PropTypes.any,
  csvProps: PropTypes.any,
  pageClick: PropTypes.any,
  data: PropTypes.array.isRequired,
  page: PropTypes.number.isRequired,
  loading: PropTypes.bool.isRequired,
  totalSize: PropTypes.number.isRequired,
  sizePerPage: PropTypes.number.isRequired,
  onTableChange: PropTypes.func.isRequired,
}

const mapDispatchToProps = (dispatch) => {
  return {
    dispatch,
  }
}
const mapStateToProps = () => ({
  // employee: state.employeeRequest.employee,
})

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(HighValueLeadSummary)
)
